<template>
<div class="row">
    <div class="col-md-12">
        <div v-show="loading !== 0" class="portlet light">
          <h2>{{ trans('form.please_wait') }}...</h2>
          <ring-loader></ring-loader>
        </div>
        <div v-show="loading === 0" class="portlet light bordered">
            <div class="portlet-title">
                <div class="caption">
                    <i class="icon-equalizer font-red-sunglo"></i>
                    <span class="caption-subject font-red-sunglo bold uppercase">raport kontrolny</span>
                </div>
            </div>
            <div class="row" style="margin-bottom: 20px;">
                <div class="form-group">
                  <label class="col-md-1 control-label">Na datę</label>
                  <div class="col-md-2">
                      <date-picker v-model="dateFrom" :time="false"></date-picker>
                    </div>
                  <div class="col-md-3">
                        <singleselect
                            v-model="brand"
                            title="Markę"
                            name="brand"
                            :options="brands"
                            label="name"
                        >
                        </singleselect>
                    </div>
                    <div class="col-md-3">
                        <button type="submit" class="btn btn-success" :disabled="disabledButton < 6" @click="generate">Generuj</button>
                    </div>
                </div>
            </div>
            <div class="portlet-body form">
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div v-show="loadingDrivers != 0" class="row">
                            <div class="col-sm-12">
                            <ring-loader></ring-loader>
                            </div>
                        </div>
                        <div v-show="loadingDrivers == 0">
                            <div class="dashboard-stat2 bordered">
                                <div class="display">
                                    <div class="number">
                                        <h3 class="font-green-sharp">
                                            <span data-counter="counterup">{{ driversReportCount }}</span>
                                        </h3>
                                        <small>
                                            <a target="_blank" href="/drivers_report/drivers_report">raport dla kierowców</a>
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div v-show="loadingStickers != 0" class="row">
                            <div class="col-sm-12">
                            <ring-loader></ring-loader>
                            </div>
                        </div>
                        <div v-show="loadingStickers == 0">
                            <div class="dashboard-stat2 bordered">
                                <div class="display" style="margin-bottom: 0">
                                    <div class="number">
                                        <h3 class="font-green-sharp">
                                            <span data-counter="counterup">{{ stickersCount }}</span>
                                        </h3>
                                        <small>naklejki na torby</small><br />
                                        <small>
                                            <a target="_blank" :href="stickerReportPartOne">
                                                część 1
                                            </a>
                                        </small>
                                        <small>
                                            <a target="_blank" :href="stickerReportPartTwo">
                                                część 2
                                            </a>
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div v-show="loadingActive != 0" class="row">
                            <div class="col-sm-12">
                            <ring-loader></ring-loader>
                            </div>
                        </div>
                        <div v-show="loadingActive == 0">
                            <div class="dashboard-stat2 bordered">
                                <div class="display">
                                    <div class="number">
                                        <h3 class="font-green-sharp">
                                            <span data-counter="counterup">{{ activeCount }}</span>
                                        </h3>
                                        <small>liczba zamówień aktywnych</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div v-show="loadingWithoutCheckboxActive != 0" class="row">
                        <div class="col-sm-12">
                        <ring-loader></ring-loader>
                        </div>
                    </div>
                    <div v-show="loadingWithoutCheckboxActive == 0">
                        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                            <div class="dashboard-stat2 bordered">
                                <div class="display">
                                    <div class="number">
                                        <h3 class="font-green-sharp">
                                            <span data-counter="counterup">{{ ordersWithoutCheckboxActiveCount }}</span>
                                        </h3>
                                        <small>numery zamówień z niezaznaczonym checkboxem "aktywne"</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                            <a
                               v-for="(orderId, index) in ordersWithoutCheckboxActive"
                               :key="index"
                               target="_blank"
                               :href="'/order/update/' + orderId"
                            >
                                {{ orderId }},
                            </a>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div v-show="loadingContactWithUs != 0" class="row">
                        <div class="col-sm-12">
                        <ring-loader></ring-loader>
                        </div>
                    </div>
                    <div v-show="loadingContactWithUs == 0">
                        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                            <div class="dashboard-stat2 bordered">
                                <div class="display">
                                    <div class="number">
                                        <h3 class="font-green-sharp">
                                            <span data-counter="counterup">{{ ordersContactWithUsCount }}</span>
                                        </h3>
                                        <small>liczba opłaconych zamówień z zaznaczonym checkboxem "skontaktuj się z nami"</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                            <a
                                v-for="(orderId, index) in ordersContactWithUs"
                                :key="index"
                                target="_blank"
                                :href="'/order/update/' + orderId"
                            >
                                {{ orderId }},
                            </a>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div v-show="loadingWrongServing != 0" class="row">
                        <div class="col-sm-12">
                        <ring-loader></ring-loader>
                        </div>
                    </div>
                    <div v-show="loadingWrongServing == 0">
                        <h1>Zgodność menu z zamówionymi posiłkami</h1>
                        <table class="table">
                            <thead>
                            <tr>
                                <th>Posiłek</th>
                                <th>Id elementu torby</th>
                                <th>Id torby</th>
                                <th>Id zamówienia</th>
                                <th>Id posiłku</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(row, index) in wrongServing" :key="index">
                                <td>
                                    <a
                                       v-if="row.selected_meal_id"
                                       :href="'/meal/show/' + row.selected_meal_id"
                                    >
                                        {{ row.meal_name }}
                                    </a>
                                    <span v-else>{{ row.meal_name }}</span>
                                </td>
                                <td><a :href="'/bag/update/' + row.bag_id">{{ row.bag_item_id }}</a></td>
                                <td><a :href="'/bag/update/' + row.bag_id">{{ row.bag_id }}</a></td>
                                <td><a :href="'/order/update/' + row.order_id">{{ row.order_id }}</a>
                                </td>
                                <td>
                                    <a
                                       v-if="row.selected_meal_id"
                                       :href="'/meal/show/' + row.selected_meal_id"
                                    >
                                        {{ row.selected_meal_id }}
                                    </a>
                                    <span v-else>{{ row.selected_meal_id }}</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import datePicker from '../../component/datePicker.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'

export default {
  name: 'ControlReport',
  components: {
    RingLoader,
    datePicker,
    Singleselect
  },
  data() {
    return {
      loading: 0,
      dateFrom: moment().locale('pl').format('YYYY-MM-DD'),
      loadingDrivers: 0,
      loadingStickers: 0,
      loadingActive: 0,
      loadingProductWithoutPayment: 0,
      loadingWithoutCheckboxActive: 0,
      loadingContactWithUs: 0,
      loadingWrongServing: 0,
      driversReportCount: 0,
      stickersCount: 0,
      activeCount: 0,
      ordersWithoutCheckboxActive: [],
      ordersContactWithUs: [],
      ordersWithoutCheckboxActiveCount: 0,
      ordersContactWithUsCount: 0,
      productWithoutPaymentCount: 0,
      wrongServing: [],
      disabledButton: 0,
      brand: null,
      brands: [],
    }
  },
  computed: {
    stickerReportPartOne() {
      return `https://easyreports.ntfy.pl/admin/report/214?file=0&date-to=${this.dateFrom}&date-from=${this.dateFrom}`
    },
    stickerReportPartTwo() {
      return `https://easyreports.ntfy.pl/admin/report/215?file=0&date-to=${this.dateFrom}&date-from=${this.dateFrom}`
    },
  },
  watch: {
    'brand': function () {
      if (this.brand) {
        this.prepare()
      } else {
        this.unsetData()
      }
    },
  },
  mounted() {
    this.getBrands()
  },
  methods: {
    getBrands() {
      this.loading++
      let url = Routing.generate('api_get_brands', { context: 'dropdown' })
      this.$http.get(url).then(response => {
        this.brands = response.data
        this.loading--
      }, response => {
        this.loading--
        this.handleAjaxError(response)
      })
    },
    async fetchDriversReport() {
      const response = await axios.get(
        `/control-report/drivers_count/${this.dateFrom}/brand/${this.brand}`
      )
      this.driversReportCount = response.data.bags
      this.loadingDrivers--
      this.disabledButton++
    },
    async fetchStickersReport() {
      const response = await axios.get(
        `/control-report/stickers_count/${this.dateFrom}/brand/${this.brand}`
      )
      this.stickersCount = response.data.bags
      this.loadingStickers--
      this.disabledButton++
    },
    async fetchActiveReport() {
      const response = await axios.get(
        `/control-report/active_count/${this.dateFrom}/brand/${this.brand}`
      )
      this.activeCount = response.data.bags.length
      this.loadingActive--
      this.disabledButton++
    },
    async fetchInActive() {
      const response = await axios.get(
        `/control-report/inactive/${this.dateFrom}/brand/${this.brand}`
      )
      this.ordersWithoutCheckboxActive = response.data.bags
      this.ordersWithoutCheckboxActiveCount = Object.keys(this.ordersWithoutCheckboxActive).length
      this.loadingWithoutCheckboxActive--
      this.disabledButton++
    },
    async fetchContactWithUs() {
      const response = await axios.get(
        `/control-report/contact_with_us/${this.dateFrom}/brand/${this.brand}`
      )
      this.ordersContactWithUs = response.data.bags
      this.ordersContactWithUsCount = Object.keys(this.ordersContactWithUs).length
      this.loadingContactWithUs--
      this.disabledButton++
    },
    async fetchBagItemsWithWrongServing() {
      const response = await axios.get(
        `/control-report/wrong_serving/${this.dateFrom}/brand/${this.brand}`
      )
      this.wrongServing = response.data.bags
      this.loadingWrongServing--
      this.disabledButton++
    },
    async generate() {
      this.disabledButton = 0
      this.loadingDrivers++
      this.loadingStickers++
      this.loadingActive++
      this.loadingProductWithoutPayment++
      this.loadingWithoutCheckboxActive++
      this.loadingContactWithUs++
      this.loadingWrongServing++
      this.fetchDriversReport()
      this.fetchStickersReport()
      this.fetchActiveReport()
      this.fetchInActive()
      this.fetchContactWithUs()
      this.fetchBagItemsWithWrongServing()
    },
    prepare() {
      this.loadingDrivers++
      this.loadingStickers++
      this.loadingActive++
      this.loadingProductWithoutPayment++
      this.loadingWithoutCheckboxActive++
      this.loadingContactWithUs++
      this.loadingWrongServing++
      this.fetchDriversReport()
      this.fetchStickersReport()
      this.fetchActiveReport()
      this.fetchInActive()
      this.fetchContactWithUs()
      this.fetchBagItemsWithWrongServing()
    },
    unsetData() {
      this.loadingDrivers = 0
      this.loadingStickers = 0
      this.loadingActive = 0
      this.loadingProductWithoutPayment = 0
      this.loadingWithoutCheckboxActive = 0
      this.loadingContactWithUs = 0
      this.loadingWrongServing = 0
      this.driversReportCount = 0
      this.stickersCount = 0
      this.activeCount = 0
      this.ordersWithoutCheckboxActive = []
      this.ordersContactWithUs = []
      this.ordersWithoutCheckboxActiveCount = 0
      this.ordersContactWithUsCount = 0
      this.productWithoutPaymentCount = 0
      this.wrongServing = []
      this.disabledButton = 0
    }
  }
}
</script>
